export default {
    accountOption: [
        {
            value: '',
            label: '全部',
        },
        {
            value: '0',
            label: '待结算',
        }, {
            value: '1',
            label: '已结算',
        },

    ],
    isfollowOption: [
        {
            value: '0',
            label: '全部方案',
        }, {
            value: '1',
            label: '跟单方案',
        },
    ],
    transferOption: [
        {
            value: '0',
            label: '全部方案',
        }, {
            value: '2',
            label: '转单',
        },
    ],
    optionslottery_type: [
        {
            value: '',
            label: '全部彩种',
        },
        {
            value: '1',
            label: '竞彩足球',
        },
        {
            value: '2',
            label: '北京单场',
        },
        {
            value: '3',
            label: '足彩',
        },
        {
            value: '5',
            label: '竞彩篮球 ',
        },
        {
            value: '6',
            label: '数字彩',
        },
    ],
    optionsorder: [
        {
            value: '',
            label: '全部',
        },
        {
            value: '20',
            label: '未接单',
        },
        {
            value: '30',
            label: '等待结账',
        },
        {
            value: '50',
            label: '出票成功',
        },
        {
            value: '80',
            label: '出票失败 ',
        },
        {
            value: '-40',
            label: '过点撤单',
        },
    ],
    joinBuyoptionsorder: [
        {
            value: '',
            label: '全部',
        },
        {
            value: '20',
            label: '未接单',
        },
        {
            value: '30',
            label: '等待结账',
        },
        {
            value: '50',
            label: '出票成功',
        },
        {
            value: '80',
            label: '出票失败 ',
        },
        {
            value: '-40',
            label: '过点撤单',
        },
        {
            value: '-1',
            label: '合买中',
        },
        // {
        //     value: '1',
        //     label: '保底成功',
        // },
        {
            value: '2',
            label: '合买成功',
        },
        {
            value: '3',
            label: '合买失败',
        },
    ],
    optionspay: [
        {
            value: '',
            label: '全部',
        }, {
            value: '1',
            label: '账本',
        }, {
            value: '2',
            label: '现金',
        },
        {
            value: '3',
            label: '扫码付',
        },
    ],
    lotteryType: [
        {
            value: 'tc_gaopin',
            label: '体彩高频',
        },
        {
            value: 'tc_shuzi',
            label: '体彩数字彩',
        },
        {
            value: 'zc',
            label: '传统足球',
        },
        {
            value: 'jc',
            label: '竞彩足球+篮球',
        },
        {
            value: 'dc',
            label: '北京单场',
        },
        {
            value: 'tc',
            label: '体彩',
        },
    ],
    deviceType: [
        {
            value: 'tc_keyboard',
            label: '体彩-键盘型投注机',
        },
        {
            value: 'dc_touch',
            label: '体彩-触摸屏型投注机',
        },
    ],
    touchBrandModel: [
        {
            value: 'TPT',
            label: '英特达(TPT)',
            children: [
                {
                    value: 'tpt2_41_line',
                    label: 'tpt2_41',
                },
                {
                    value: 'tpt2_61_line',
                    label: 'tpt2_61',
                },
            ],
        },
        {
            value: 'SPL',
            label: '北京穗彩',
            children: [
                {
                    value: 'splt_line',
                    label: 'splt',
                },
            ],
        },
    ],
    brandModel: [
        {
            value: 'TPT',
            label: '英特达(TPT)',
            children: [
                {
                    value: 'TPT-II',
                    label: 'TPT-II',
                },
            ],
        },
        {
            value: 'GOT',
            label: '高腾(GOT)',
            children: [
                {
                    value: 'C8',
                    label: 'C8',
                },
                {
                    value: '其他型号',
                    label: '其他型号',
                },
            ],
        },
        {
            value: 'SPL',
            label: '穗彩',
            children: [
                {
                    value: 'SPLT',
                    label: 'SPLT',
                },
            ],
        },
        {
            value: 'KT',
            label: '洛图',
            children: [
                {
                    value: 'KT301',
                    label: 'KT301',
                },
            ],
        },
        {
            value: 'HCA',
            label: '海信',
            children: [
                {
                    value: 'HCA600',
                    label: 'HCA600',
                },
            ],
        },
    ],
    portOption: [],
    lotteryTypesArr: [
        { label: 'dc', name: '北京单场' },
        { label: 'jc', name: '竞彩足球+篮球' },
        { label: 'zc', name: '传统足球' },
        { label: 'tc_shuzi', name: '体彩数字彩' },
    ],
    lotteryTypeOptions: [
        {
            value: 'SportteryWDL',
            label: '竞彩让球胜平负',
        },
        {
            value: 'SportteryNWDL',
            label: '竞彩胜平负',
        },
        {
            value: 'SportteryScore',
            label: '竞彩比分',
        },
        {
            value: 'SportteryTotalGoals',
            label: '竞彩总进球',
        },
        {
            value: 'SportteryHalfFull',
            label: '竞彩半全场',
        },
        {
            value: 'SportteryWS',
            label: '篮彩胜分差',
        },
        {
            value: 'SportteryWL',
            label: '篮彩胜负',
        },
        {
            value: 'SportteryHWL',
            label: '篮球让分胜负',
        },
        {
            value: 'SportteryBS',
            label: '篮球大小分',
        },
        {
            value: 'SportterySoccerMix',
            label: '竞彩足球混合过关',
        },
        {
            value: 'SportteryBasketMix',
            label: '竞彩篮球混合过关',
        },
    ],
    lotterType:[
        { label: 1, value: "竞彩足球" },
        { label: 2, value: "北京单场" },
        { label: 3, value: "足彩" },
        { label: 4, value: "胜负过关" },
        { label: 5, value: "竞彩篮球" },
        { label: 6, value: "超级大乐透" },
        { label: 7, value: "排列三" },
        { label: 8, value: "排列五" },
        { label: 9, value: "七星彩" },
        { label: 11, value: "福彩3D" },
        { label: 12, value: "双色球" },
        { label: 14, value: "快乐8" }
    ]
};
